var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "labor-tpl" }, [
    _c("form", [
      _c("h1", [_vm._v("产品经销合同")]),
      _c("p", { staticClass: "l3" }, [
        _vm._v("\n      甲方："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.aName,
              expression: "form.aName"
            }
          ],
          staticClass: "default",
          attrs: { name: "aName", type: "text" },
          domProps: { value: _vm.form.aName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "aName", $event.target.value)
            }
          }
        })
      ]),
      _c("p", { staticClass: "l3" }, [
        _vm._v("\n      乙方："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.bName,
              expression: "form.bName"
            }
          ],
          staticClass: "default",
          attrs: { name: "bName", type: "text" },
          domProps: { value: _vm.form.bName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "bName", $event.target.value)
            }
          }
        })
      ]),
      _c("p", [
        _vm._v(
          "\n      鉴于双方在平等自愿的基础上就甲方委托乙方作为上述产品的\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.productAdd,
              expression: "form.productAdd"
            }
          ],
          staticClass: "default2",
          attrs: { type: "text", name: "productAdd" },
          domProps: { value: _vm.form.productAdd },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "productAdd", $event.target.value)
            }
          }
        }),
        _vm._v("地区经销商事宜，特订立协议如下：\n    ")
      ]),
      _c("p", [_vm._v("\n      第一条：定义\n    ")]),
      _c("p", [
        _vm._v("\n      一、产品本协议中所称“产品”，是指"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.productType,
              expression: "form.productType"
            }
          ],
          staticClass: "default33",
          attrs: { type: "text", name: "productType" },
          domProps: { value: _vm.form.productType },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "productType", $event.target.value)
            }
          }
        }),
        _vm._v("系列产品。\n    ")
      ]),
      _c("p", [
        _vm._v("\n      二、地区本协议中所称“地区”，是指"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.productAg,
              expression: "form.productAg"
            }
          ],
          staticClass: "default4",
          attrs: { type: "text", name: "productAg" },
          domProps: { value: _vm.form.productAg },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "productAg", $event.target.value)
            }
          }
        }),
        _vm._v("经双方经书面同意的其他地区。\n    ")
      ]),
      _c("p", [
        _vm._v(
          "\n      三、商标和专名本协议中所称“商标”和“专名”，是分别指\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.productAllName,
              expression: "form.productAllName"
            }
          ],
          staticClass: "default2",
          attrs: { name: "productAllName", type: "text" },
          domProps: { value: _vm.form.productAllName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "productAllName", $event.target.value)
            }
          }
        }),
        _vm._v("（商标的全称和专名的全称）。指定产品的中文名称："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.productName,
              expression: "form.productName"
            }
          ],
          staticClass: "default33",
          attrs: { type: "text", name: "productName" },
          domProps: { value: _vm.form.productName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "productName", $event.target.value)
            }
          }
        }),
        _vm._v(
          "。（暂定名，乙方将可能在此产品的整体CI策划中，给予其名称全新策划）\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      第二条：经销权甲方兹给予乙方以“商标”和“专名”向“地区”内客户总经销“产品”的权利。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      第三条：专管权一、交易甲方不得再将“产品”售予、让予或以其他方式使“地区”内乙方以外的任何个人、公司或其他主体取得“产品”。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      二、委托甲方不得委托“地区”内乙方以外的其他个人、公司或其他主体作为其经销商，以进口和销售“产品”。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      三、询购甲方收到“地区”内任何客户有关“产品”的询购，均应交给乙方。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      四、再进口甲方应采取适当措施防止他人在“地区”内出售“产品”，并不得将“产品”卖给甲方知道的或有理由相信拟在“地区”内再进口或出售“产品”的第三者。\n    "
        )
      ]),
      _c("p", [_vm._v("第四条：价格、条件一、价格")]),
      _c("p", [
        _vm._v(
          "\n      1、 甲方给予乙方的价格和条件，应随时由甲方和乙方商定，此项价格和条件的确定并应考虑到正常贸易惯例及经常存在的市场竞争情况，使双方从销售中获得相当利润。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "2、 甲方给予乙方一个较稳定的市场价格，如有变动，也是每年年初发给的年度价格表。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "3、 如有产品价格变动，甲方应在改变价格和折扣的30天前书面通知乙方，所有改变价格期限之前双方签定的合同一律保证价格，并按正常交货期交货。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "4、 乙方所享受的代理折扣由双方另行商定，但甲方应当保证乙方应获得不低于\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.discount,
              expression: "form.discount"
            }
          ],
          staticClass: "default2",
          attrs: { name: "discount", type: "text" },
          domProps: { value: _vm.form.discount },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "discount", $event.target.value)
            }
          }
        }),
        _vm._v("的折扣。\n    ")
      ]),
      _c("p", [
        _vm._v("二、单独合同在每次具体购买产品时，双方应缔结单独合同。\n    ")
      ]),
      _c("p", [
        _vm._v(
          "\n      三、最惠条款甲方声明，本协议中各项条款是甲方现在给予经销商和制造商最优惠的条款，\n      今后如甲方向任何其他经销商或制造商销售“产品”时提供比本协议更有利于买方的条件时，甲方应立即以书面通知乙方，并向乙方提供此项更有利的条件。\n    "
        )
      ]),
      _c("p", [_vm._v("第五条：甲方的责任甲方同意在下列方面承担义务：\n    ")]),
      _c("p", [
        _vm._v(
          "1、 承诺并保证作为 产品的中国总代理完全有资格与乙方签订本协议。\n    "
        )
      ]),
      _c("p", [_vm._v("2、 自费提供样品和一切可以供应的广告资料。\n    ")]),
      _c("p", [
        _vm._v(
          "3、 提供现行的国内价目表，并将价目表内任何预期的变更迅速通知乙方。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "4、 甲方将向乙方免费提供一定数量的产品资料。大批量的资料在必要的情况下可由乙方申请甲方提供。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "5、 应及时向乙方提供其产品在国际市场上最新的行业动态信息，经常提供有利于推销产品的意见，以便乙方能采取多元化的市场推广策略和销售方式。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "6、 甲方将对乙方的工程师提供全面的技术培训，并提供足够的技术支持。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "7、 甲方对于乙方售出的产品，凡是属于产品质量问题的而引起的损失，一切均由甲方承担责任或给予免费更换。\n    "
        )
      ]),
      _c("p", [_vm._v("第六条：乙方的责任\n    ")]),
      _c("p", [
        _vm._v(
          "1、 为在“地区”内推销“产品”并为客户服务，应自费提供和保持一个有经营能力的机构，\n      并尽一切努力争取达到有利于甲方为利用“地区”内各种销售机会而制定的销售指标。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "2、 乙方应根据需要，在“地区”内发展区域性代理商和分销商，签订合同和管理将由乙方独立负责。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "3、 乙方将配备足够的销售工程师和技术工程师来配合市场销售的需求，他们会全面了解系列产品的特性及用途，并能够承担培训，现场检测服务和操作示范等任务。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "4、 供给甲方有关销售“产品”的详细报告，以及尽可能多的有关“地区”内各种销售机会和竞争者推销活动的情报。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "5、 乙方应尊重和保护甲方的知识产权，并保证不将售出的任何甲方产品`复制后用于商业目的。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      第七条：双方关系根据本协议所建立的甲方和乙方，在协议有效期内的关系仅属卖方和买方的关系。任何一方均无权对某一第三者代表另一方，\n      或以另一方的名义签订合同。本协议并不产生代理权，如果任何一方以另一方的名义或以另一方代理人的名义行事，以致另一方遭受损失时，\n      该导致损失的一方，应使受害的一方不负担由此而发生的费用。双方并未也无意建立任何代理、合伙、合营企业或雇主和雇员的关系。\n    "
        )
      ]),
      _c("p", [_vm._v("\n      第八条：甲方名称等的使用\n    ")]),
      _c("p", [
        _vm._v(
          "一、特许乙方得为商业上的目的使用“商标”和“行名”或它们的简称或变称，并得标明自己为“地区”内“产品”的经销商。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "二、注册如乙方提出要求，甲方应自费负责为“商标”和“专名”在“地区”内办理申请、正式注册并保持其效力。\n    "
        )
      ]),
      _c("p", [
        _vm._v("第九条：期限、终止本协议自"),
        _c("input", {
          staticClass: "default2",
          attrs: { type: "text" },
          domProps: { value: _vm._f("format")(new Date(), "YYYY年MM月DD日") }
        }),
        _vm._v("起生效，\n      有效期为"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yearNum,
              expression: "form.yearNum"
            }
          ],
          staticClass: "default15",
          attrs: { name: "yearNum", type: "text" },
          domProps: { value: _vm.form.yearNum },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yearNum", $event.target.value)
            }
          }
        }),
        _vm._v("年，如遇下列情况和条件，本协议应终止：\n    ")
      ]),
      _c("p", [
        _vm._v(
          "\n      １，如任何一方有违背本协议的实质行为，另一方得以书面通知该方，叙述此种违约行为，\n      并说明除非该方对此种违约行为按本节规定加以纠正，否则另一方将按照本节规定终止本协议。如该通知发出后九十天内仍未得到纠正，则本协议根据这一事实在上述九十天期终时即时终止。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      ２，如任何一方根据破产法或债务人救济法提出或同意提出破产申请或其他救济申请，\n      或被裁定破产，或解散，或清理，或对债权人作任何转让，或对该方指定了产业管理人或类似人员，则在上述任何情况下，另一方得在任何时侯以书面通知即终止本协议。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "３，如遇本协议所规定的某种不可抗力事由，以致协议一方在超过\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.dayNum,
              expression: "form.dayNum"
            }
          ],
          staticClass: "default15",
          attrs: { name: "dayNum", type: "text" },
          domProps: { value: _vm.form.dayNum },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "dayNum", $event.target.value)
            }
          }
        }),
        _vm._v(
          "天期限后尚无法履行其义务时，则另一方可在任何时候以书面通知立即终止本协议。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "第十条：解约的影响凡在本协议终止前双方间已发生而尚未了结的任何债务，或在本协议终止前由于一方违约而发生的另一方的损害赔偿请求权，均不受本协议终止的影响。\n    "
        )
      ]),
      _c("p", [_vm._v("第十一条：保证")]),
      _c("p", [
        _vm._v(
          "一、标准甲方向乙方保证，所有“产品”均符合“地区”内的标准。可以出售，并适合销售目的。甲方并保证“产品”在原料和制造工艺方面均符合质量标准。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "二、免受损失凡因“产品”被指称质量低劣，或因侵犯专利、商标，或因在“地区”内销售或使用“产品”而引起的其他任何类似的责任事由，甲方应保护乙方，使之不受损失。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "三、质量如乙方发现任何“产品”质量低劣，并将此事实通知甲方，甲方应按乙方提出的要求，立即予以调换或对乙方给予补偿，\n      其费用由甲方自行负担。对由于上述调换或补偿而引起的损害，乙方不丧失其索赔权。\n    "
        )
      ]),
      _c("p", [_vm._v("第十二条：一般条款")]),
      _c("p", [
        _vm._v(
          "\n      一、不可抗力本协议任何一方如遇到非所能控制的事由，以致直接或间接地造成任何延误或无法履行本协议及（或）各个单独合同的一部或全部条款时，\n      则在此范围内得以免除其责任。此类事由包括但不限于：水灾、火灾、海啸、地震、以外事故或机械故障、天灾、战争、封锁、禁运、劫持、战争威胁、\n      战争性情况、扣押、暴动、动员、暴乱、非暴力骚乱、革命、制裁、抢劫、罢工、劳动纠纷、工业干扰、动力供应不足、缺乏正常运输工具\n      、金融恐慌、交易所关闭、国有化、禁止进口或出口、拒发政府命令、敌对行动或其他类似或不类似上述原因而非该方或双方所能控制的。\n      如由于立法或政府行政命令以致任何一方或双方失去根据本协议应得的利益时，\n      双方应重新审查本协议的条款以便恢复任何一方或双方根据本协议原已取得的同样的相应的地位。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "由于发生不可抗力事由的书面的通知，应由受影响一方以合理速度送达另一方。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "二、转让本协议任何一方在未征得另一方书面同意之前，不得转让本协议或本协议内规定的任何权利和义务。任何转让在未征得对方事前明确的书面同意之前，应属无效。\n    "
        )
      ]),
      _c("p", [
        _vm._v("三、商业机密本协议任何一方均不得在本协议期限内或期满后"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.endDayNum,
              expression: "form.endDayNum"
            }
          ],
          staticClass: "default15",
          attrs: { name: "endDayNum", type: "text" },
          domProps: { value: _vm.form.endDayNum },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "endDayNum", $event.target.value)
            }
          }
        }),
        _vm._v(
          "内，对不论与另一方有否竞争的任何个人、行号或公司泄漏有关另一方业务经营或行情的任何消息或情报。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      四、通知根据本协议规定所发出的任何通知应以中文和英文做成书面，并以预付邮资的航空挂号信，按上文载明的地址或本协议任何一方可能按本节规定通知送达的其他地址，\n      送交收件人。任何此种通知应视为在付邮日后第"
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.recDay,
              expression: "form.recDay"
            }
          ],
          staticClass: "default15",
          attrs: { name: "recDay", type: "text" },
          domProps: { value: _vm.form.recDay },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "recDay", $event.target.value)
            }
          }
        }),
        _vm._v(
          "\n      个营业日送达。而此种通知正式付邮的证件，应视为送达此种通知的充分证明。\n    "
        )
      ]),
      _c("p", [
        _vm._v("五、适用法律和贸易条款本协议的成立、效力、解释和履行，应以"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.country,
              expression: "form.country"
            }
          ],
          staticClass: "default1",
          attrs: { name: "country", type: "text" },
          domProps: { value: _vm.form.country },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "country", $event.target.value)
            }
          }
        }),
        _vm._v("国法律为准。\n      本协议内的贸易条件应服从最新修订的"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.countryTips,
              expression: "form.countryTips"
            }
          ],
          staticClass: "default1",
          attrs: { name: "countryTips", type: "text" },
          domProps: { value: _vm.form.countryTips },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "countryTips", $event.target.value)
            }
          }
        }),
        _vm._v("条款的规定和解释。\n    ")
      ]),
      _c("p", [
        _vm._v(
          "六、仲裁所有其他一切来自本协议或关于本协议、或关于违背本协议的争执或异议，在双方通过善意协商未能达成和解时，\n      应提交苏州仲裁委员会按其仲裁规则进行仲裁，裁决应视为终局裁决，对协议双方均有约束力。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "七、可分割性本协议内各条款应视为可以分割，本协议内任何条款的无效，不应影响本协议其余条款的效力。"
        )
      ]),
      _c("p", [
        _vm._v(
          "八、保留权利协议任何一方在任何时候不坚持另一方执行本协议的任何条款时，不应视为放弃此项条款或放弃以后坚持另一方执行此项条款的权利。"
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      九、其他约定本协议包括双方关于本协议主题的全部协议和谅解，并取代双方以前关于本协议主题以书面或口头提出的任何性质的讨论所达成的一切协议和谅解，\n      除本协议有明文规定者外，其他有关本协议主题的任何条件、定义、保证或声明，对双方均无约束力。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "关于本协议的任何更正、修改、更换或变更，以书面为之，并明确与本协议有关、由协议双方正式授权的人员或代表签署。"
        )
      ]),
      _c("p", [
        _vm._v(
          "为证明起见，本协议做成一式两份，在本协议起自所载的日期内双方正式授权的人员或代表签署。"
        )
      ]),
      _c("div", { staticClass: "list" }, [
        _c("p", [
          _vm._v("\n        甲方（盖章）："),
          _c("br"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.cName,
                expression: "form.cName"
              }
            ],
            staticClass: "default",
            attrs: { type: "text", name: "aName" },
            domProps: { value: _vm.form.cName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "cName", $event.target.value)
              }
            }
          })
        ]),
        _c("p", [
          _vm._v("\n        乙方（签字）："),
          _c("br"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.dName,
                expression: "form.dName"
              }
            ],
            staticClass: "default",
            attrs: { type: "text", name: "bName" },
            domProps: { value: _vm.form.dName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "dName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("input", {
        attrs: { type: "hidden", value: "product", name: "tempType" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a4e52ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4e52ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/sys-contract/product.vue
// module id = aMcN
// module chunks = 57